var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject } from 'mobx-react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { t } from 'helpers/i18n';
import History from 'helpers/History';
import { sections } from 'scenes/Main';
import UserLogout from 'modules/Users/containers/UserLogout';
import { Button } from 'elements';
let NavBarDesktop = class NavBarDesktop extends Component {
    constructor() {
        super(...arguments);
        this.handleLink = activePath => () => {
            console.log('NavBarDesktop - handleLink', activePath);
            this.setState({ activePath });
            History.push(activePath);
        };
    }
    render() {
        return (React.createElement(Wrapper, null,
            sections(this.props.store.users.user).map(section => (React.createElement(DropDown, { key: section.name },
                React.createElement(StyledButton, { onClick: () => { } }, t(section.name)),
                React.createElement(DropDownContent, null, section.links.map(link => (React.createElement(DropDownLink, { onClick: this.handleLink(link.path), key: link.name }, t(link.name)))))))),
            React.createElement(UserLogout, null)));
    }
};
NavBarDesktop = __decorate([
    inject('store')
], NavBarDesktop);
export default NavBarDesktop;
const Wrapper = cxs('div')({
    /*float: 'right',
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',*/
    zIndex: 1,
});
const DropDown = cxs('div')({
    float: 'left',
    overflow: 'hidden',
    ':hover div': {
        display: 'block'
    },
    ':hover > button': {
        color: Theme.color.primary
    }
});
const StyledButton = cxs(Button)({});
const DropDownContent = cxs('div')({
    display: 'none',
    position: 'absolute',
    backgroundColor: Theme.color.background,
    border: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    borderTopWidth: 0,
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2)',
});
const DropDownLink = cxs(Button)({
    display: 'block',
    width: '100%',
    float: 'none',
    borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    ':last-child': {
        borderWidth: 0
    },
    ':hover': {
        color: Theme.color.primary
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/components/NavBarDesktop.tsx
// module id = 499
// module chunks = 0